<template>
  <div class="block-list-item">
    <!--googleoff: noindex-->
    <TeaserListItem
      v-bind="props"
      class="list-item"
      :padded="padded"
      :loading="loading"
      :priority="priority"
      :show-date="showDate"
      :show-label="showLabel"
      :heading-level="headingLevel"
      :analytics="analytics"
      :aria-hidden="!isMobile"
    />
    <!--googleon: noindex-->
    <TeaserBlock
      v-bind="props"
      class="block"
      aspect-ratio="4x3"
      :show-date="showDate"
      :show-label="showLabel"
      :padded="false"
      :loading="loading"
      :priority="priority"
      :heading-level="headingLevel"
      :analytics="analytics"
      :aria-hidden="isMobile"
    />
  </div>
</template>

<script setup lang="ts">
// switches between list-item and block based on breakpoint (using css)
import type { IAnalytics, IImageLoadingSettings, ITeaser } from '~~/types/local_types';
import useBreakpointsStore from '~/stores/breakpoints';
const breakpointsStore = useBreakpointsStore();
const { getCurrentBreakpoint } = storeToRefs(breakpointsStore);
const isMobile = ref<boolean>(true);

interface IProps extends ITeaser, IImageLoadingSettings {
  padded?: boolean;
  showDate?: boolean;
  showLabel?: boolean;
  headingLevel?: number;
  analytics?: IAnalytics;
}

const props = withDefaults(defineProps<IProps>(), {
  loading: 'lazy',
  priority: 'auto',
  padded: false,
  showDate: true,
  showLabel: true,
  headingLevel: 3,
  analytics: undefined,
});

onMounted(() => {
  watch(
    getCurrentBreakpoint,
    (newValue) => {
      if (newValue) {
        isMobile.value = ['xs', 'sm'].includes(newValue?.name);
      }
    },
    { immediate: true },
  );
});
</script>

<style scoped lang="postcss">
.block-list-item {
  display: contents;
}

.list-item {
  @media (--md-viewport) {
    display: none;
    visibility: hidden;
  }
}

.block {
  display: none;
  visibility: hidden;

  @media (--md-viewport) {
    display: block;
    visibility: visible;
  }
}
</style>
